import { render, staticRenderFns } from "./melanoma.vue?vue&type=template&id=6d1d92a6&scoped=true&"
import script from "./melanoma.vue?vue&type=script&lang=js&"
export * from "./melanoma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1d92a6",
  null
  
)

export default component.exports